import { gql } from '@apollo/client'

export default gql`
  mutation duplicateProject($id: ID!) {
    duplicateProject(id: $id) {
      id
    }
  }
`
